import { Autocomplete, LoadScript } from '@react-google-maps/api';
import React, { useState, useEffect } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css'
import Select from 'react-select';
import store from '../redux/Store'
import moment from 'moment';
import { ApiCall, ApiKey } from '../common/Apikey';
import { ThreeDots } from 'react-loader-spinner';
import VerifyModel from './VerifyModel';
import $ from 'jquery';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { Tooltip as ReactTooltip } from "react-tooltip";
import AddonModel from './AddonModel';

function SingaporeBook() {

  const AutocompleteRestrict = {
    types: ['geocode', 'establishment'],
    componentRestrictions: { country: ["sg", "my"] },
  };

  const cartData = useSelector((state) => state.cart.AddCart);

  let timeConstraints = {
    minutes: {
      step: 5
    }
  }

  // addon
  const [AddonShow, setAddonShow] = useState(0);
  const [AddonStatus, setAddonStatus] = useState(0);
  const [ReAddonStatus, setReAddonStatus] = useState(0);
  const [OverallVehicle, setOverallVehicle] = useState();
  const [VehicleAddonData, setVehicleAddonData] = useState();
  const [hasRendered, setHasRendered] = useState(false);
  const [AddonData, setAddonData] = useState([]);
  const [ReAddonData, setReAddonData] = useState([]);
  const [AddonTripType, setAddonTripType] = useState('from');

  const AddonModelOpen = () => {
    setVehicleAddonData([])
    setHasRendered(false);
    setAddonTripType('from')
    if (AddonStatus == 0) {
      OverallVehicle.filter(function (option) {
        if (option.id == vehicle_type) {
          setVehicleAddonData(option)
        }
      })
      setHasRendered(true);
      setAddonStatus(1)
      setTimeout(() => {
        $('#AddonDataModel').click();
      }, 1000);
    } else {
      setAddonStatus(0)
      setAddonData([])
    }
  }

  const AddonModelEdit = () => {
    setVehicleAddonData([])
    setHasRendered(false);
    setAddonTripType('from')
    OverallVehicle.filter(function (option) {
      if (option.id == vehicle_type) {
        setVehicleAddonData(option)
      }
    })
    setHasRendered(true);
    setTimeout(() => {
      $('#AddonDataModel').click();
    }, 1000);
  }

  const AddonModelOpenRe = () => {
    // console.log('sdsdsd')
    setVehicleAddonData([])
    setHasRendered(false);
    setAddonTripType('return')
    if (ReAddonStatus == 0) {
      OverallVehicle.filter(function (option) {
        if (option.id == vehicle_type) {
          setVehicleAddonData(option)
        }
      })
      setHasRendered(true);
      setReAddonStatus(1)
      setTimeout(() => {
        $('#AddonDataModel').click();
      }, 1000);
    } else {
      setReAddonStatus(0)
      setReAddonData([])
    }
  }

  const AddonModelEditRe = () => {
    setVehicleAddonData([])
    setHasRendered(false);
    setAddonTripType('return')
    OverallVehicle.filter(function (option) {
      if (option.id == vehicle_type) {
        setVehicleAddonData(option)
      }
    })
    setHasRendered(true);
    setTimeout(() => {
      $('#AddonDataModel').click();
    }, 1000);
  }

  const getAddon = async (data) => {
    const addonData = await data;
    if(addonData != 'close'){
      if (AddonTripType == 'from') {
        addonData.length > 0 ? setAddonStatus(1) : setAddonStatus(0);
        setAddonData([])
        setAddonData(addonData)
      } else {
        addonData.length > 0 ? setReAddonStatus(1) : setReAddonStatus(0);
        setReAddonData([])
        setReAddonData(addonData)
      }
    }
    setHasRendered(false);
  }

  const [from_places, setFromPlaces] = useState("")
  const [from_lat, setFromLat] = useState("")
  const [from_lon, setFromLon] = useState("")
  const [pickup_location, setPickupLocation] = useState("")
  const [pick_name, setFromPlaceName] = useState("")
  const [to_places, setToPlaces] = useState("")
  const [to_lat, setToLat] = useState("")
  const [to_lon, setToLon] = useState("")
  const [drop_location, setDropLocation] = useState("")
  const [drop_name, setDropPlaceName] = useState("")
  const [main_category, setMainCategory] = useState("")
  const [sub_category, setSubCategory] = useState("")
  const [vehicle_type, setVehicleType] = useState("")
  const [short_name, setShortName] = useState("")
  const [main_name, setMainName] = useState("")
  const [email, setEmail] = useState("")
  const [cc, setCc] = useState("+65")
  const [phone, setPhone] = useState("")
  const [comment, setComment] = useState("")
  const [SigDate, setSigDate] = useState("")
  const [SigTime, setSigTime] = useState("")
  const [formError, setFormError] = useState({ pickup: "", drop: "", mainc: "", sub: "", vehicle: "", short: "", main: "", cc: "", phone: "", date: "", time: "", rpickup: "", rdrop: "", rdate: "", rtime: "", emailErr: "" })

  const [ReturnDiv, setReturnDiv] = useState(0)
  const [rfrom_places, setRFromPlaces] = useState("")
  const [rfrom_lat, setRFromLat] = useState("")
  const [rfrom_lon, setRFromLon] = useState("")
  const [rpickup_location, setRPickupLocation] = useState("")
  const [rto_places, setRToPlaces] = useState("")
  const [rto_lat, setRToLat] = useState("")
  const [rto_lon, setRToLon] = useState("")
  const [rdrop_location, setRDropLocation] = useState("")
  const [rcomment, setRComment] = useState("")
  const [rvehicle_type, setRVehicleType] = useState("")
  const [ReSigDate, setReSigDate] = useState("")
  const [ReSigTime, setReSigTime] = useState("")
  const [driver_payout_amount, setDriverPayoutAmount] = useState("")
  const [rdriver_payout_amount, setRDriverPayoutAmount] = useState("")

  const [email_verify, setEmailVerify] = useState(0)
  const [phone_verify, setPhoneVerify] = useState(0)
  const [main_option, setMainOption] = useState([
    { value: '', name: "main_category", label: <div>Main Category</div> }
  ])
  const [sub_option, setSubOption] = useState([
    { value: '', name: 'sub_category', label: <div>Sub Category</div> },
  ])
  const [vehicle_option, setVehicleOption] = useState([
    { value: '', name: 'vehicle_type', text: 'car', label: <div>Vehicle Type </div> }
  ])
  const [country_code, setCountryCode] = useState([]);
  const [cart_button, setCartButton] = useState(0);
  const [main_disable, setMainDisable] = useState(0)

  const [mailverifybtn, setmailverifybtn] = useState(0)
  const [mobileverifybtn, setmobileverifybtn] = useState(0)

  const [showfare, setShowFare] = useState("from")
  const [fareData, setFareData] = useState([])
  const [FareTotalAmount, setFareTotalAmount] = useState(0)

  const [refareData, setFareDataRe] = useState([])
  const [ReFareTotalAmount, setFareTotalAmountRe] = useState(0)

  // max passenger and luggage
  const [MaxPassenger, setMaxPassenger] = useState(1);
  const [MaxLuggage, setMaxLuggage] = useState(0);
  const [vehicleshow, setvehicleshow] = useState(0);

  const maxpassengerIn = (event) => {
    let value = MaxPassenger;
    value++;
    setMaxPassenger(value)
  }

  const maxpassengerOut = (event) => {
    let value = MaxPassenger;
    if (value > 1) {
      value--
    }
    setMaxPassenger(value)
  }

  const maxluggageIn = (event) => {
    let value = MaxLuggage;
    value++;
    setMaxLuggage(value)
  }

  const maxluggageOut = (event) => {
    let value = MaxLuggage;
    if (value > 0) {
      value--
    }
    setMaxLuggage(value)
  }

  const onDateChange = (event) => {
    setSigDate(event)
  }

  const onTimeChange = (event) => {
    const timeValue = new Date(event);
    const formattedTime = moment(timeValue).format('hh:mm a');
    setSigTime(formattedTime)
  }

  const onReDateChange = (event) => {
    setReSigDate(event)
  }

  const onReTimeChange = (event) => {
    const timeValue = new Date(event);
    const formattedTime = moment(timeValue).format('hh:mm a');
    setReSigTime(formattedTime)
  }

  let timeProps = {
    placeholder: 'Time',
    disabled: false
  }

  let timePropsE = {
    placeholder: 'Time',
    disabled: true
  }

  const ReturnSwitch = () => {
    if (ReturnDiv == 0) {
      setReturnDiv(1)
    } else {
      setReturnDiv(0)
    }
  }

  // pickup
  const fromLoad = (autocomplete) => {
    setFromPlaces(autocomplete)
  }

  const onFromPlaceChanged = async () => {
    if (from_places !== null) {
      var pickLat = from_places.getPlace().geometry.location.lat()
      var pickLon = from_places.getPlace().geometry.location.lng()
      var pickAdd = from_places.getPlace().formatted_address
      var pickName = from_places.getPlace().name

      setFromLat(pickLat)
      setFromLon(pickLon)
      setPickupLocation(pickAdd)
      setFromPlaceName(pickName);
      // return data
      setRToLat(pickLat)
      setRToLon(pickLon)
      setRDropLocation(pickAdd)
      // store localstorage
      localStorage.setItem('pick_up', pickName);
      const PickPosition = {
        lat: pickLat,
        lng: pickLon
      }
      localStorage.setItem('pickupPosition', JSON.stringify(PickPosition))
      window.dispatchEvent(new Event("storage"));
    }
  }

  // drop
  const toLoad = (autocomplete) => {
    setToPlaces(autocomplete)
  }

  const onToPlaceChanged = async () => {
    if (to_places !== null) {
      var dropLat = to_places.getPlace().geometry.location.lat()
      var dropLon = to_places.getPlace().geometry.location.lng()
      var dropAdd = to_places.getPlace().formatted_address
      var dropName = to_places.getPlace().name
      setToLat(dropLat)
      setToLon(dropLon)
      setDropLocation(dropAdd)
      setDropPlaceName(dropName);
      // return data
      setRFromLat(dropLat)
      setRFromLon(dropLon)
      setRPickupLocation(dropAdd)
      // localstorage
      localStorage.setItem('drop', dropName);
      const DropPosition = {
        lat: dropLat,
        lng: dropLon
      }
      localStorage.setItem('dropoffPosition', JSON.stringify(DropPosition))
      window.dispatchEvent(new Event("storage"));
    }
  }

  // return pick
  const rfromLoad = (autocomplete) => {
    setRFromPlaces(autocomplete)
  }

  const onrFromPlaceChanged = async () => {
    if (rfrom_places !== null) {
      var pickRLat = rfrom_places.getPlace().geometry.location.lat()
      var pickRLon = rfrom_places.getPlace().geometry.location.lng()
      var pickRAdd = rfrom_places.getPlace().formatted_address
      var pickRName = rfrom_places.getPlace().name

      setRFromLat(pickRLat)
      setRFromLon(pickRLon)
      setRPickupLocation(pickRAdd)
      // localstroage
      localStorage.setItem('pick_up', pickRName);
      const PickPosition = {
        lat: pickRLat,
        lng: pickRLon
      }
      localStorage.setItem('pickupPosition', JSON.stringify(PickPosition))
      window.dispatchEvent(new Event("storage"));
    }
  }

  // return drop
  const rtoLoad = (autocomplete) => {
    setRToPlaces(autocomplete)
  }

  const onrToPlaceChanged = async () => {
    if (rto_places !== null) {
      var dropRLat = rto_places.getPlace().geometry.location.lat()
      var dropRLon = rto_places.getPlace().geometry.location.lng()
      var dropRAdd = rto_places.getPlace().formatted_address
      var dropRName = rto_places.getPlace().name

      setRToLat(dropRLat)
      setRToLon(dropRLon)
      setRDropLocation(dropRAdd)
      // local storage
      localStorage.setItem('drop', dropRName);
      const DropPosition = {
        lat: dropRLat,
        lng: dropRLon
      }
      localStorage.setItem('dropoffPosition', JSON.stringify(DropPosition))
      window.dispatchEvent(new Event("storage"));
    }
  }

  const selectChange = (event) => {
    if (event.name == 'main_category') {
      setMainCategory(event.value)
    } else if (event.name == 'sub_category') {
      setSubCategory(event.value)
    } else if (event.name == 'vehicle_type') {
      setVehicleType(event.value)
      setRVehicleType(event.text)
      // addon old hide
      setAddonData([]);
      setHasRendered(false);
      setAddonStatus(0);
      setAddonShow(0);
      // addon check
      OverallVehicle.filter(function (option) {
        if (option.id == event.value && option.addon_services.length > 0) {
          // setAddonShow(1);
        }
      })
    }
  }

  const inputChange = () => {
    let { name, value } = event.target;
    if (name == 'short_name') {
      setShortName(value)
    } else if (name == 'main_name') {
      setMainName(value)
    } else if (name == 'cc') {
      setCc(value)
    } else if (name == 'phone') {
      setPhone(value)
    }else if (name == 'amount') {
      if (value.includes('.')) {
          const parts = value.split('.');
          if (parts[1].length > 2) {
              value = parts[0] + '.' + parts[1].slice(0, 2);
          }
        }
      setDriverPayoutAmount(value);
  } else if (name == 'ramount') {
      if (value.includes('.')) {
          const parts = value.split('.');
          if (parts[1].length > 2) {
              value = parts[0] + '.' + parts[1].slice(0, 2);
          }
        }
      setRDriverPayoutAmount(value)
  } else if (name == 'rcomment') {
      setRComment(value)
    } else if (name == 'email') {
      setEmail(value)
    } else {
      setComment(value)
    }
  }

  const FormValidation = () => {
    let isValid = true;
    setFormError({})
    if (pickup_location.trim() == "") {
      isValid = false;
      setFormError(prevError => ({ ...prevError, 'pickup': 'Enter Pickup Location' }))
    }
    if (drop_location.trim() == "") {
      isValid = false;
      setFormError(prevError => ({ ...prevError, 'drop': 'Enter Drop Location' }))
    }
    // if (main_category == "") {
    //   isValid = false;
    //   setFormError(prevError => ({ ...prevError, 'mainc': 'Select Main Category' }))
    // }
    // if (sub_category == "") {
    //   isValid = false;
    //   setFormError(prevError => ({ ...prevError, 'sub': 'Select Sub Category' }))
    // }
    if (vehicle_type == "") {
      isValid = false;
      setFormError(prevError => ({ ...prevError, 'vehicle': 'Select Vehicle Type' }))
    }
    if (driver_payout_amount == "") {
      isValid = false;
      setFormError(prevError => ({ ...prevError, 'amount': 'Enter Driver Payout Amount' }))
  }
    // if (short_name.trim() == "") {
    //   isValid = false;
    //   setFormError(prevError => ({ ...prevError, 'short': 'Enter Short Name' }))
    // }
    // if (main_name.trim() == "") {
    //   isValid = false;
    //   setFormError(prevError => ({ ...prevError, 'main': 'Enter Passenger Name' }))
    // }
    // if (cc.trim() == "") {
    //   isValid = false;
    //   setFormError(prevError => ({ ...prevError, 'cc': 'Select CC' }))
    // }
    // if (phone.trim() == "") {
    //   isValid = false;
    //   setFormError(prevError => ({ ...prevError, 'phone': 'Enter Phone number' }))
    // }
    if (SigDate == "") {
      isValid = false;
      setFormError(prevError => ({ ...prevError, 'date': 'Select Date' }))
    }
    if (SigTime == "") {
      isValid = false;
      setFormError(prevError => ({ ...prevError, 'time': 'Select Time' }))
    }
    // return validation
    if (ReturnDiv == 1 && rpickup_location.trim() == "") {
      isValid = false;
      setFormError(prevError => ({ ...prevError, 'rpickup': 'Enter Pickup Location' }))
    }
    if (ReturnDiv == 1 && rdrop_location == "") {
      isValid = false;
      setFormError(prevError => ({ ...prevError, 'rdrop': 'Enter Drop Location' }))
    }
    if (ReturnDiv == 1 && rdriver_payout_amount == "") {
      isValid = false;
      setFormError(prevError => ({ ...prevError, 'ramount': 'Enter Driver Payout Amount' }))
    }
    if (ReturnDiv == 1 && ReSigDate == "") {
      isValid = false;
      setFormError(prevError => ({ ...prevError, 'rdate': 'Select Date' }))
    }
    if (ReturnDiv == 1 && ReSigTime == "") {
      isValid = false;
      setFormError(prevError => ({ ...prevError, 'rtime': 'Select Time' }))
    }

    return isValid;
  }

  function rideTime(date, time) {
    var changeDate = moment(date).format('DD/MM/YYYY') + ' ' + time;
    var flightArrivalTime = new Date(changeDate)
    var calTime = 5 * 60000;
    var pick_upTime = new Date(flightArrivalTime.getTime() - calTime)

    return moment(pick_upTime).format('YYYY-MM-DD HH:mm')
  }

  //booking
  async function SingaporeNow(event) {
    event.preventDefault();
    setCartButton(1)
    if (FormValidation()) {

      if (ReturnDiv == 1) {
        var from_date = moment(SigDate).format('YYYY-MM-DD') + ' ' + moment(SigTime, 'hh:mm A').format('HH:mm:ss')
        var to_date = moment(ReSigDate).format('YYYY-MM-DD') + ' ' + moment(ReSigTime, 'hh:mm A').format('HH:mm:ss')
        if (new Date(from_date).getTime() >= new Date(to_date).getTime()) {
          toast.error('Return time must be greater than 15 mins.', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setCartButton(0)
          return false
        }
      }

      const Values = await FareApi()
      if (Values.message != "success") {
        toast.error(Values.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setCartButton(0)
        return false;
      } else if (Values.result.total_distance == 0) {
        toast.error('Something went wrong. Please try again in a min. Error Code: D0001', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setCartButton(0)
        return false;
      }

      // return
      if (ReturnDiv == 1) {
        const RValues = await FareReturnApi()
        if (RValues.message != "success") {
          toast.error(Values.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setCartButton(0)
          return false;
        } else if (RValues.result.return_trip.total_distance == 0) {
          toast.error('Something went wrong. Please try again in a min. Error Code: D0001', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setCartButton(0)
          return false;
        }
      }

      // if (Values.message == "success") {
      //   // let ride_time = rideTime(moment(SigDate).format('YYYY-MM-DD'), SigTime)
      //   var surge = JSON.stringify(Values.result.surgeprice)
      //   store.dispatch({
      //     type: "addToCart",
      //     payload: {
      //       pick_up: pickup_location,
      //       pickup_lat: from_lat,
      //       pickup_lon: from_lon,
      //       drop_location: drop_location,
      //       no_of_adults: MaxPassenger,
      //       luggage: MaxLuggage,
      //       drop_lat: to_lat,
      //       drop_lon: to_lon,
      //       customer_id: "",
      //       mode: "ridelater",
      //       rider_type: 3,
      //       user_type: 3,
      //       trip_type: 3,
      //       request_type: "web",
      //       service_type: "malaysia",
      //       return_type: "",
      //       return_vehicle_type: "",
      //       return_ride_time: "",
      //       return_vehicle_id: "",
      //       main_vehicle_id: main_category,
      //       sub_vehicle_id: sub_category,
      //       vehicle_id: vehicle_type,
      //       date: moment(SigDate).format('YYYY-MM-DD'),
      //       ride_date: moment(SigDate).format('YYYY-MM-DD'),
      //       pick_up_time: SigTime,
      //       // ride_time: ride_time,
      //       short_name: "",
      //       passenger_name: main_name,
      //       passenger_phone_code: cc,
      //       passenger_phone_number: cc + '' + phone,
      //       schedulePromo: "",
      //       special_note: comment,
      //       return_pickup_lat: "",
      //       return_pickup_lon: "",
      //       return_drop_lat: "",
      //       return_drop_lon: "",
      //       type: "Malaysia",
      //       vehicle_typeName: rvehicle_type,
      //       total_amount: Math.ceil(Values.result.amount),
      //       total_distance: Values.result.total_distance,
      //       total_minute: Values.result.total_minute,
      //       extra_stops: Values.result.extra_stops,
      //       extra_stop_status: Values.result.extra_stop_status,
      //       per_stop_fare: Values.result.per_stop_price,
      //       per_stop_increase_cap_fare: Values.result.per_stop_increase_price,
      //       per_stop_multiple: Values.result.per_stop_multiple,
      //       per_stop_increase_multiple: Values.result.per_stop_increase_multiple,
      //       overall_extra_stop_cost: Values.result.overall_extra_stop_cost,
      //       vehicle_type: rvehicle_type,
      //       today_date: moment(SigDate).format('YYYY-MM-DD'),
      //       minimum_distance_fare: Values.result.minimum_fare,
      //       minimum_distance_fare_status: Values.result.minimum_fare_status,
      //       sub_total: Values.result.sub_total,
      //       cap_price: Values.result.cap_price,
      //       cap_status: Values.result.capped_status,
      //       base_fare: Values.result.base_fare,
      //       surge_price: Values.result.surgeprice.length > 0 ? surge : '[]',
      //       city_type: 2,
      //       addon_amount: Values.result.addon_amount,
      //       addon_data: Values.result.addon_data.length > 0 ? Values.result.addon_data : ''
      //     }
      //   });
      //   if (ReturnDiv != 1) {
      //     toast.success('Booking added into cart', {
      //       position: "top-right",
      //       autoClose: 3000,
      //       hideProgressBar: false,
      //       closeOnClick: true,
      //       pauseOnHover: true,
      //       draggable: true,
      //       progress: undefined,
      //       theme: "colored",
      //     });

      //     setTimeout(() => {
      //       window.location.reload();
      //     }, 5000);
      //   }
      // }
      if (Values.message == "success") {
        // let ride_time = rideTime(moment(SigDate).format('YYYY-MM-DD'), SigTime)
        var surge = JSON.stringify(0)
        store.dispatch({
          type: "addToCart",
          payload: {
            pick_up: pickup_location,
            pickup_lat: from_lat,
            pickup_lon: from_lon,
            drop_location: drop_location,
            no_of_adults: MaxPassenger,
            luggage: MaxLuggage,
            drop_lat: to_lat,
            drop_lon: to_lon,
            customer_id: "",
            mode: "ridelater",
            rider_type: 3,
            user_type: 3,
            trip_type: 3,
            request_type: "web",
            service_type: "malaysia",
            return_type: "",
            return_vehicle_type: "",
            return_ride_time: "",
            return_vehicle_id: "",
            main_vehicle_id: main_category,
            sub_vehicle_id: sub_category,
            vehicle_id: vehicle_type,
            date: moment(SigDate).format('YYYY-MM-DD'),
            ride_date: moment(SigDate).format('YYYY-MM-DD'),
            pick_up_time: SigTime,
            // ride_time: ride_time,
            short_name: "",
            passenger_name: main_name,
            passenger_phone_code: cc,
            passenger_phone_number: cc + '' + phone,
            schedulePromo: "",
            special_note: comment,
            return_pickup_lat: "",
            return_pickup_lon: "",
            return_drop_lat: "",
            return_drop_lon: "",
            type: "Malaysia",
            vehicle_typeName: rvehicle_type,
            total_amount: Math.ceil(driver_payout_amount),
            total_distance: 0,
            total_minute: 0,
            // extra_stops: 0,
            // extra_stop_status: 0,
            per_stop_fare: 0,
            per_stop_increase_cap_fare: 0,
            per_stop_multiple: 0,
            per_stop_increase_multiple: 0,
            overall_extra_stop_cost: 0,
            vehicle_type: rvehicle_type,
            today_date: moment(SigDate).format('YYYY-MM-DD'),
            minimum_distance_fare: 0,
            minimum_distance_fare_status: 0,
            sub_total: Math.ceil(driver_payout_amount),
            cap_price: Math.ceil(driver_payout_amount),
            cap_status: 0,
            base_fare: 0,
            surge_price: 0 > 0 ? surge : '[]',
            city_type: 2,
            addon_amount: 0,
            addon_data: 0 > 0 ? 0 : ''
          }
        });
        if (ReturnDiv != 1) {
          toast.success('Booking added into cart', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          setTimeout(() => {
            window.location.reload();
          }, 5000);
        }
      }else {
        toast.error(Values.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setCartButton(0)
        return false
      }

      // if (ReturnDiv == 1) {
      //   const RValues = await FareReturnApi()
      //   if (RValues.message == "success") {
      //     // let ride_time = rideTime(moment(ReSigDate).format('YYYY-MM-DD'), ReSigTime)
      //     var surge = JSON.stringify(RValues.result.return_trip.surgeprice)
      //     store.dispatch({
      //       type: "addToCart",
      //       payload: {
      //         pick_up: rpickup_location,
      //         pickup_lat: rfrom_lat,
      //         pickup_lon: rfrom_lon,
      //         drop_location: rdrop_location,
      //         no_of_adults: MaxPassenger,
      //         luggage: MaxLuggage,
      //         drop_lat: rto_lat,
      //         drop_lon: rto_lon,
      //         customer_id: "",
      //         mode: "ridelater",
      //         rider_type: 3,
      //         user_type: 3,
      //         trip_type: 3,
      //         request_type: "web",
      //         service_type: "malaysia",
      //         return_type: "return",
      //         return_vehicle_type: rvehicle_type,
      //         return_ride_time: "",
      //         ride_date: moment(ReSigDate).format('YYYY-MM-DD'),
      //         return_vehicle_id: vehicle_type,
      //         main_vehicle_id: main_category,
      //         sub_vehicle_id: sub_category,
      //         vehicle_id: vehicle_type,
      //         date: moment(ReSigDate).format('YYYY-MM-DD'),
      //         pick_up_time: SigTime,
      //         // ride_time: ride_time,
      //         short_name: "",
      //         passenger_name: main_name,
      //         passenger_phone_code: cc,
      //         passenger_phone_number: cc + '' + phone,
      //         schedulePromo: "",
      //         special_note: comment,
      //         return_pick_up: rpickup_location,
      //         return_pickup_lat: rfrom_lat,
      //         return_pickup_lon: rfrom_lon,
      //         return_drop_location: rdrop_location,
      //         return_drop_lat: rto_lat,
      //         return_drop_lon: rto_lon,
      //         return_ride_date: moment(ReSigDate).format('YYYY-MM-DD'),
      //         return_pick_up_time: ReSigTime,
      //         return_promocode: "",
      //         return_special_note: rcomment,
      //         type: "Malaysia",
      //         vehicle_typeName: rvehicle_type,
      //         total_amount: Math.ceil(RValues.result.return_trip.amount),
      //         total_distance: RValues.result.return_trip.total_distance,
      //         total_minute: RValues.result.return_trip.total_minute,
      //         extra_stops: RValues.result.return_trip.extra_stops,
      //         extra_stop_status: RValues.result.return_trip.extra_stop_status,
      //         per_stop_fare: RValues.result.return_trip.per_stop_price,
      //         per_stop_increase_cap_fare: RValues.result.return_trip.per_stop_increase_price,
      //         per_stop_multiple: RValues.result.return_trip.per_stop_multiple,
      //         per_stop_increase_multiple: RValues.result.return_trip.per_stop_increase_multiple,
      //         overall_extra_stop_cost: RValues.result.return_trip.overall_extra_stop_cost,
      //         vehicle_type: rvehicle_type,
      //         today_date: moment(ReSigDate).format('YYYY-MM-DD'),
      //         minimum_distance_fare: RValues.result.return_trip.minimum_fare,
      //         minimum_distance_fare_status: RValues.result.return_trip.minimum_fare_status,
      //         sub_total: RValues.result.return_trip.sub_total,
      //         cap_price: RValues.result.return_trip.cap_price,
      //         cap_status: RValues.result.return_trip.capped_status,
      //         base_fare: RValues.result.return_trip.base_fare,
      //         surge_price: RValues.result.return_trip.surgeprice.length > 0 ? surge : '[]',
      //         city_type: 2,
      //         addon_amount: RValues.result.return_trip.addon_amount,
      //         addon_data: RValues.result.return_trip.addon_data.length > 0 ? RValues.result.return_trip.addon_data : ''
      //       }
      //     });
      //     toast.success('Booking added into cart', {
      //       position: "top-right",
      //       autoClose: 3000,
      //       hideProgressBar: false,
      //       closeOnClick: true,
      //       pauseOnHover: true,
      //       draggable: true,
      //       progress: undefined,
      //       theme: "colored",
      //     });

      //     setTimeout(() => {
      //       window.location.reload();
      //     }, 5000);
      //   } else {
      //     toast.error(RValues.message, {
      //       position: "top-right",
      //       autoClose: 3000,
      //       hideProgressBar: false,
      //       closeOnClick: true,
      //       pauseOnHover: true,
      //       draggable: true,
      //       progress: undefined,
      //       theme: "colored",
      //     });
      //     setCartButton(0)
      //     return false
      //   }
      // }
      if (ReturnDiv == 1) {
        const RValues = await FareReturnApi()
        if (RValues.message == "success") {
          // let ride_time = rideTime(moment(ReSigDate).format('YYYY-MM-DD'), ReSigTime)
          var surge = JSON.stringify(0)
          store.dispatch({
            type: "addToCart",
            payload: {
              pick_up: rpickup_location,
              pickup_lat: rfrom_lat,
              pickup_lon: rfrom_lon,
              drop_location: rdrop_location,
              no_of_adults: MaxPassenger,
              luggage: MaxLuggage,
              drop_lat: rto_lat,
              drop_lon: rto_lon,
              customer_id: "",
              mode: "ridelater",
              rider_type: 3,
              user_type: 3,
              trip_type: 3,
              request_type: "web",
              service_type: "malaysia",
              return_type: "return",
              return_vehicle_type: rvehicle_type,
              return_ride_time: "",
              ride_date: moment(ReSigDate).format('YYYY-MM-DD'),
              return_vehicle_id: vehicle_type,
              main_vehicle_id: main_category,
              sub_vehicle_id: sub_category,
              vehicle_id: vehicle_type,
              date: moment(ReSigDate).format('YYYY-MM-DD'),
              pick_up_time: SigTime,
              // ride_time: ride_time,
              short_name: "",
              passenger_name: main_name,
              passenger_phone_code: cc,
              passenger_phone_number: cc + '' + phone,
              schedulePromo: "",
              special_note: comment,
              return_pick_up: rpickup_location,
              return_pickup_lat: rfrom_lat,
              return_pickup_lon: rfrom_lon,
              return_drop_location: rdrop_location,
              return_drop_lat: rto_lat,
              return_drop_lon: rto_lon,
              return_ride_date: moment(ReSigDate).format('YYYY-MM-DD'),
              return_pick_up_time: ReSigTime,
              return_promocode: "",
              return_special_note: rcomment,
              type: "Malaysia",
              vehicle_typeName: rvehicle_type,
              total_amount: Math.ceil(rdriver_payout_amount),
              total_distance: 0,
              total_minute: 0,
              // extra_stops: 0,
              // extra_stop_status: 0,
              per_stop_fare: 0,
              per_stop_increase_cap_fare: 0,
              per_stop_multiple: 0,
              per_stop_increase_multiple: 0,
              overall_extra_stop_cost: 0,
              vehicle_type: rvehicle_type,
              today_date: moment(ReSigDate).format('YYYY-MM-DD'),
              minimum_distance_fare: 0,
              minimum_distance_fare_status: 0,
              sub_total: Math.ceil(rdriver_payout_amount),
              cap_price: Math.ceil(rdriver_payout_amount),
              cap_status: 0,
              base_fare: 0,
              surge_price: 0 > 0 ? surge : '[]',
              city_type: 2,
              addon_amount: 0,
              addon_data: 0 > 0 ? 0 : ''
            }
          });
          toast.success('Booking added into cart', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          setTimeout(() => {
            window.location.reload();
          }, 5000);
        } else {
          toast.error(RValues.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setCartButton(0)
          return false
        }
      } else {
        setCartButton(0)
      }
    } else {
      setCartButton(0)
    }
  }

  const Selectstyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: '25px',
    }),
  };

  useEffect(() => {
    setSubOption([
      { value: '', name: 'sub_category', label: <div>Sub Category</div> },
    ])
    SubApiCall()
  }, [main_category])

  const SubApiCall = async () => {
    let data = {
      category_id: main_category
    };

    await ApiCall('sub_categories', data).then((data) => {
      if (data.message === "category listed successfully.") {
        const subData = data.result;
        if (subData.length > 0) {
          const newSubOptions = subData.map((data, i) => ({
            value: data.id,
            name: 'sub_category',
            label: (
              <div>
                <img src={ApiKey.main_name + '/' + data.image} className="option-image" />
                {data.subcategory_name}
              </div>
            ),
          }));

          setSubOption((prevSubOptions) => [...prevSubOptions, ...newSubOptions]);
        }
      }
    }).catch(err => console.log(err));
  }

  useEffect(() => {
    setVehicleOption([
      { value: '', name: 'vehicle_type', text: 'car', label: <div>Vehicle Type </div> }
    ])
    VehiApiCall()
  }, [sub_category])

  const VehiApiCall = async () => {
    let data = {
      subcategory_id: sub_category
    };
    await ApiCall('vehicleCategory', data).then((data) => {
      if (data.message === "category listed successfully.") {
        const vechData = data.result;
        if (vechData.length > 0) {
          const newVechOptions = vechData.map((data, i) => ({
            value: data.id,
            name: 'vehicle_type',
            text: data.vehicle_type,
            label: (
              <div>
                <img src={ApiKey.main_name + '/' + data.image} className="option-vehimage" />
                {data.vehicle_type.split('_').join(" ")}
              </div>
            ),
          }));
          setVehicleOption((prevSubOptions) => [...prevSubOptions, ...newVechOptions])
        }
      }
    }).catch(err => console.log(err));
  }

  async function SingaporeFare() {
    if (pickup_location != '' && drop_location != '' && SigDate != '' && SigTime != '' && vehicle_type != '') {
      const Values = await FareApi()
      if (Values.message == "success") {
        if (Values.result.capped_status == 1 && Values.result.extra_stop_status == 1) {
          setFareTotalAmount(Math.ceil(Values.result.amount))
        } else if (Values.result.capped_status == 1 && Values.result.surgeprice.length > 0) {
          setFareTotalAmount(Math.ceil(Values.result.amount))
        } else if (Values.result.capped_status == 1) {
          setFareTotalAmount(Math.ceil(Values.result.cap_price))
        } else {
          setFareTotalAmount(Math.ceil(Values.result.amount))
        }
        setShowFare('from')
        setFareData(Values.result)
      } else {
        toast.error(Values.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  }

  async function SingaporeReturnFare() {
    if (rpickup_location != '' && rdrop_location != '' && ReSigDate != '' && ReSigTime != '' && vehicle_type != '') {
      const Values = await FareReturnApi()
      if (Values.message == "success") {
        if (Values.result.return_trip.capped_status == 1 && Values.result.return_trip.extra_stop_status == 1) {
          setFareTotalAmountRe(Math.ceil(Values.result.return_trip.amount))
        } else if (Values.result.return_trip.capped_status == 1 && Values.result.return_trip.surgeprice.length > 0) {
          setFareTotalAmountRe(Math.ceil(Values.result.return_trip.amount))
        } else if (Values.result.return_trip.capped_status == 1) {
          setFareTotalAmountRe(Math.ceil(Values.result.return_trip.cap_price))
        } else {
          setFareTotalAmountRe(Math.ceil(Values.result.return_trip.amount))
        }
        setShowFare('return')
        setFareDataRe(Values.result.return_trip)
      } else {
        toast.error(Values.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  }

  const FareApi = async () => {

    let data = {
      customer_id: "",
      pickup_lat: from_lat,
      pickup_lon: from_lon,
      drop_lat: to_lat,
      drop_lon: to_lon,
      vehicle_id: vehicle_type,
      service_type: "malaysia",
      ride_date: moment(SigDate).format('YYYY-MM-DD'),
      ride_time: SigTime,
      promocode: "",
      date: moment(SigDate).format('YYYY-MM-DD'),
      pick_up_time: SigTime,
      guest_type: 1,
      addon_services: AddonData.length > 0 ? JSON.stringify(AddonData) : '',
    }
    var FareData = {};
    await ApiCall('guest_fare_estimate', data).then((data) => {
      FareData = data;
    }).catch(err => console.log(err));

    return FareData
  }

  const FareReturnApi = async () => {

    let data = {
      customer_id: "",
      pickup_lat: from_lat,
      pickup_lon: from_lon,
      drop_lat: to_lat,
      drop_lon: to_lon,
      vehicle_id: vehicle_type,
      service_type: "malaysia",
      ride_date: moment(SigDate).format('YYYY-MM-DD'),
      ride_time: SigTime,
      promocode: "",
      return_type: "return",
      return_vehicle_id: vehicle_type,
      return_pickup_lat: rfrom_lat,
      return_pickup_lon: rfrom_lon,
      return_drop_lat: rto_lat,
      return_drop_lon: rto_lon,
      time_validate: "1",
      return_ride_date: moment(ReSigDate).format('YYYY-MM-DD'),
      return_ride_time: ReSigTime,
      return_promocode: "",
      date: moment(ReSigDate).format('YYYY-MM-DD'),
      pick_up_time: ReSigTime,
      guest_type: 1,
      return_addon_services: ReAddonData.length > 0 ? JSON.stringify(ReAddonData) : '',
    }
    var FareData = {};
    await ApiCall('guest_fare_estimate', data).then((data) => {
      FareData = data;
    }).catch(err => console.log(err));

    return FareData
  }

  const getCheck = async (token) => {
    const tokenMessage = await token;
    if (tokenMessage == 'sucessEmail') {
      setEmailVerify(1)
      toast.success('OTP verified successfully', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

    } else if (tokenMessage == 'sucessMobile') {
      setPhoneVerify(1)
      toast.success('OTP verified successfully', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  }

  async function MainApi() {
    let data = {};
    await ApiCall('getMainCategoryGuest', data).then((data) => {
      if (data.success === "success") {
        const mainData = data.data;
        if (mainData.length > 0) {
          const newMainData = mainData.map((data, i) => ({
            value: data.id,
            name: 'main_category',
            label: (
              <div>
                <img src={ApiKey.main_name + '/' + data.image} className="option-image" />
                {data.category_name}
              </div>
            ),
          }));

          setMainOption((prevSubOptions) => [...prevSubOptions, ...newMainData]);
        }
      } else {
        toast.error('Main category not found.', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }).catch(err => console.log(err));
  }

  async function MainTextApi() {
    const searchParams = new URLSearchParams(window.location.search);
    const vehicle_name = searchParams.get('type');
    let data = {
      vehicle_name: vehicle_name
    }
    await ApiCall('getMainCategoryId', data).then((data) => {
      if (data.success === "success") {
        setMainCategory(data.data)
        setMainDisable(1)
        setTimeout(() => {
          SubApiCall()
        }, 2000);
      } else {
        toast.error('Main category not found.', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }).catch(err => console.log(err));
  }

  async function CountryCodeApi() {
    let data = {}
    await ApiCall('countrycode', data).then((data) => {
      if (data.success === "success") {
        setCountryCode(data.data)
      }
    }).catch(err => console.log(err));
  }

  async function VehicleApi() {
    let data = {
      service_type: 'malaysia',
      no_of_seats: MaxPassenger,
      luggage: MaxLuggage
    };
    await ApiCall('getVehicleCategoryGuest', data).then((data) => {
      if (data.success === "success") {
        const vechData = data.data;
        setVehicleOption([
          { value: '', name: 'vehicle_type', text: 'car', label: <div>Vehicle Type </div> }
        ])
        setOverallVehicle("");
        if (vechData.length > 0) {
          const newVechOptions = vechData.map((data, i) => ({
            value: data.id,
            name: 'vehicle_type',
            text: data.vehicle_type,
            label: (
              <div>
                <img src={ApiKey.main_name + '/' + data.image} className="option-vehimage" />
                {data.vehicle_type.split('_').join(" ")}
              </div>
            ),
          }));
          setVehicleOption((prevSubOptions) => [...prevSubOptions, ...newVechOptions])
          setvehicleshow(1);
          setOverallVehicle(vechData)
        }
      } else {
        toast.error('Vehicle category not found.', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }).catch(err => console.log(err));
  }

  async function VehicleTextApi() {
    const searchParams = new URLSearchParams(window.location.search);
    const vehicle_name = searchParams.get('type');
    let data = {
      vehicle_name: vehicle_name
    }
    await ApiCall('getVehicleId', data).then((data) => {
      if (data.success === "success") {
        setVehicleType(data.data.id)
        setRVehicleType(data.data.vehicle_type)
        setMainDisable(1)
        setTimeout(() => {
          SubApiCall()
        }, 2000);
      } else {
        toast.error('Main category not found.', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }).catch(err => console.log(err));
  }

  async function VehicleGroupApi() {
    const searchParams = new URLSearchParams(window.location.search);
    const groupName = searchParams.get('type');
    let data = {
      group_name: groupName,
      service_type: 'malaysia',
      no_of_seats: MaxPassenger,
      luggage: MaxLuggage
    }
    await ApiCall('vehicleCategoryGroupList', data).then((data) => {
      if (data.message === "success") {
        const vechGrpData = data.result;
        setVehicleOption([
          { value: '', name: 'vehicle_type', text: 'car', label: <div>Vehicle Type </div> }
        ])
        setOverallVehicle("")
        if (vechGrpData.length > 0) {
          const newVechGrpOptions = vechGrpData.map((data, i) => ({
            value: data.id,
            name: 'vehicle_type',
            text: data.vehicle_type,
            label: (
              <div>
                <img src={ApiKey.main_name + '/' + data.image} className="option-vehimage" />
                {data.vehicle_type.split('_').join(" ")}
              </div>
            ),
          }));
          setVehicleOption((prevSubOptions) => [...prevSubOptions, ...newVechGrpOptions])
          setvehicleshow(1);
          setOverallVehicle(vechGrpData)
        }
      } else {
        VehicleApi()
      }
    }).catch(err => console.log(err));
  }

  const MaxChooseVeh = () => {
    setVehicleType("");
    setRVehicleType("")
    setVehicleOption([
      { value: '', name: 'vehicle_type', text: 'car', label: <div>Vehicle Type </div> }
    ])
    const searchParams = new URLSearchParams(window.location.search);
    const vehicle_name = searchParams.get('type');
    if (vehicle_name == null) {
      VehicleApi()
    } else if (vehicle_name != 'all') {
      VehicleGroupApi()
    } else {
      VehicleApi()
    }
  }

  useEffect(() => {
    // setvehicleshow(0)
    MaxChooseVeh()
  }, [MaxLuggage, MaxPassenger])

  useEffect(() => {
    SingaporeFare()
  }, [pickup_location, drop_location, SigDate, SigTime, main_category, sub_category, vehicle_type, AddonData])

  useEffect(() => {
    SingaporeReturnFare()
  }, [rpickup_location, rdrop_location, ReSigDate, ReSigTime, main_category, sub_category, vehicle_type, ReAddonData])

  useEffect(() => {
    // const searchParams = new URLSearchParams(window.location.search);
    // const vehicle_name = searchParams.get('type');
    CountryCodeApi()
    // if (vehicle_name == null) {
    //   // MainApi()
    //   VehicleApi()
    // } else if (vehicle_name != 'all') {
    //   // MainTextApi()
    //   VehicleTextApi()
    //   setTimeout(() => {
    //     // MainApi()
    //     VehicleApi()
    //   }, 5000);
    // } else {
    //   // MainApi()
    //   VehicleApi()
    // }
    //clear localstorage
    localStorage.removeItem('stopPosition0')
    localStorage.removeItem('stopPosition1')
    localStorage.removeItem('pick_up')
    localStorage.removeItem('pickupPosition')
    localStorage.removeItem('drop')
    localStorage.removeItem('dropoffPosition')
    window.dispatchEvent(new Event("storage"));
  }, [])

  return (
    <>
      <div className='formDiv' id="singaporeBook">
        <form autoComplete='off'>

          <div className='row'>
            <div className='col-lg-6 col-md-12 col-12 mt-1'>
              <h5 className=''>Booking Details</h5>
              {/* <hr /> */}
              <div className='row mb-1'>
                {/* <p>Pick Date/Time</p> */}
                <div className='col-lg-6 col-12 mt-1'>
                  <div className="inner-addon right-addon">
                    <i className="glyphicon glyphicon-user fa fa-calendar textColor"></i>
                    {/* <input type="text" className="form-control rounded-pill" placeholder='Date'/> */}
                    <DatePicker
                      selected={SigDate}
                      onChange={onDateChange}
                      dateFormat='yyyy-MM-dd'
                      minDate={new Date}
                      className='form-control'
                      placeholderText='Date'
                    />
                    <span className="error-field text-dark" style={{ marginLeft: "0.5rem" }}>{formError.date}</span>
                  </div>
                </div>
                <div className='col-lg-6 col-12 mt-1'>
                  <div className="inner-addon right-addon">
                    <i className="glyphicon glyphicon-user fa fa-clock textColor"></i>
                    {/* <input type="text" className="form-control rounded-pill" placeholder='Time'/> */}
                    <Datetime dateFormat={false}
                      inputProps={timeProps}
                      timeConstraints={timeConstraints}
                      onChange={onTimeChange}
                      // value={SigTime}
                    />
                    <span className="error-field text-dark" style={{ marginLeft: "0.5rem" }}>{formError.time}</span>
                  </div>
                </div>
              </div>

              <div className="">
                {/* <label className="form-label">Pickup Location</label> */}
                <Autocomplete onLoad={fromLoad} onPlaceChanged={onFromPlaceChanged} options={AutocompleteRestrict}>
                  <input type="text" className="form-control rounded-pill" id="pickup" name="pickup" placeholder='Pickup Location' />
                </Autocomplete>
                <span className="error-field text-dark" style={{ marginLeft: "0.5rem" }}>{formError.pickup}</span>
              </div>

              <div className='row'>
                <div className="col-lg-8 col-12">
                  {/* <label className="form-label"></label> */}
                  <Autocomplete onLoad={toLoad} onPlaceChanged={onToPlaceChanged} options={AutocompleteRestrict}>
                    <input type="text" className="form-control rounded-pill" id="drop" name="drop" placeholder='Drop Location' />
                  </Autocomplete>
                  <span className="error-field text-dark" style={{ marginLeft: "0.5rem" }}>{formError.drop}</span>
                </div>
                <div className="col-lg-2 col-6">
                  <div className='marginDiv'>
                    <span className="no_of" style={{ color: 'white', fontSize: '14px' }}>Passenger <i class="fa-solid fa-circle-info" data-tooltip-id="tooltip-passenger"></i></span>
                    <ReactTooltip id="tooltip-passenger" place="top">
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span>Include all ages,</span>
                        <span>exclude wheelchair user in wheelchair</span>
                      </div>
                    </ReactTooltip>
                    <div className="buttons d-flex align-items-center m-0 p-0">
                      <p className='airport-decrement-btn' id="DecP" onClick={maxpassengerOut}> &nbsp; - &nbsp;</p>
                      <span className="number_padd" id="passenger-input">{MaxPassenger}</span>
                      <p className='airport-increment-btn' id="DecP" onClick={maxpassengerIn}> &nbsp; + &nbsp;</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-6">
                  <div className='marginDiv'>
                    <span className="no_of" style={{ color: 'white', fontSize: '14px' }}>Luggage <i class="fa-solid fa-circle-info" data-tooltip-id="tooltip-luggage"></i></span>
                    <ReactTooltip id="tooltip-luggage" place="top">
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span>The standard size is 24 and above.</span>
                        <span>If greater than 24, please count as 2</span>
                      </div>
                    </ReactTooltip>
                    <div className="buttons d-flex align-items-center m-0 p-0">
                      <p className='airport-decrement-btn' id="DecP" onClick={maxluggageOut}> &nbsp; - &nbsp;</p>
                      <span className="number_padd" id="wheelchair-input">{MaxLuggage}</span>
                      <p className='airport-increment-btn' id="DecP" onClick={maxluggageIn}> &nbsp; + &nbsp;</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className='row mb-2'>
            <p>Choose your Vehicle</p>
            <div className='col-12'>
              <div className="mb-1">
                <Select
                  styles={Selectstyles}
                  options={main_option}
                  placeholder="Main Category"
                  onChange={selectChange}
                  isDisabled={main_disable == 1 ? true : false}
                  value={main_option.filter(function (option) {
                    return option.value === main_category;
                  })}
                />
                <span className="error-field text-dark" style={{ marginLeft: "0.5rem" }}>{formError.mainc}</span>
              </div>
            </div>
            <div className='col-12'>
              <div className="mb-1">
                <Select
                  styles={Selectstyles}
                  options={sub_option}
                  placeholder="Sub Category"
                  onChange={selectChange}
                />
                <span className="error-field text-dark" style={{ marginLeft: "0.5rem" }}>{formError.sub}</span>
              </div>
            </div>
          </div> */}


              <div className="row mt-2">
                {/* <div className='col-lg-4 col-md-4 col-12 splitCol'>
                  <input type="button" className="form-control btn rounded-pill billCart" value='Choose Your Vehicle' onClick={MaxChooseVeh} />
                </div> */}
                {/* className={vehicleshow == 1 ? "col-lg-8 col-md-8 col-12" : "col-lg-8 col-md-8 col-12 vehopacity"} */}
                <div className="col-lg-8 col-md-8 col-1">
                  {/* <label className="form-label">Choose Vehicle Type</label> */}
                  <Select
                    styles={Selectstyles}
                    options={vehicle_option}
                    placeholder="Vehicle Type"
                    onChange={selectChange}
                    // isDisabled={main_disable == 1 ? true : false}
                    // isDisabled={vehicleshow == 1 ? false : true}
                    value={vehicle_option.filter(function (option) {
                      return option.value === vehicle_type;
                    })}
                  />
                  <span className="error-field text-dark" style={{ marginLeft: "0.5rem" }}>{formError.vehicle}</span>
                </div>
                <div className={AddonShow == 1 ? 'col-lg-4 col-md-4 col-12' : 'd-none'}>
                  {/* <span className="no_of" style={{ color: 'white' }}>&nbsp;</span> */}
                  <div class="form-check d-flex justify-content-between">
                    {/* <div>
                      <input class="form-check-input" type="checkbox" id="addon" name="addon" onChange={AddonModelOpen} checked={AddonStatus == 1 ? true : false} />
                      <label class="form-check-label">
                        Add-on Services
                      </label>
                    </div> */}
                    <i className='fa fa-circle-info ms-1' data-tooltip-id="tooltip-addon"></i>
                    <p className={AddonData.length > 0 ? 'text-end addon-edit' : 'text-end addon-edit d-none'} onClick={AddonModelEdit}>Edit</p>
                    <ReactTooltip id="tooltip-addon" place="top">
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {AddonData.length > 0 ? AddonData.map((item, key) => {
                          return (
                            <span>{item.name} - {item.count}</span>
                          )
                        }) : <><p>No add-on selected</p></>}
                      </div>
                    </ReactTooltip>
                  </div>
                </div>
              </div>

              {/* <div className="confirnBook mb-1">
                <p className="text-center confirm-title pt-2">Fare Breakdown</p>

                <div className='row justify-content-center'>
                  <div className="col-md-11 col-11 pt-1">
                    <div className='row'>
                      <div className={fareData != '' && (fareData.surgeprice.length > 0 || fareData.addon_data.length > 0) ? 'col-lg-6 col-12 checkout p-1' : 'd-none'}>
                        <div className="container surge_con" id='fare-scroll'>
                          <table id="fare-table">
                            {fareData != '' ? <>
                              {fareData.surgeprice.length > 0 ? fareData.surgeprice.map((data, i) => {
                                return (<><tr>
                                  <td style={{ fontSize: '14px' }}>{data.name}</td>
                                  <td>:</td>
                                  <td>
                                    <p className='m-0 p-0 dist-charge'><span>S$</span> {parseFloat(data.surge_amount).toFixed(2)}</p>
                                  </td>
                                </tr>
                                  <tr>
                                    <td colSpan={3}><hr /></td>
                                  </tr></>)
                              }) : <></>}</> : <></>
                            }
                            {fareData != '' ? <>
                              {fareData.addon_data.length > 0 ? fareData.addon_data.map((data, i) => {
                                return (<><tr>
                                  <td style={{ fontSize: '14px' }}>{data.name}</td>
                                  <td>:</td>
                                  <td>
                                    <p className='m-0 p-0 dist-charge'><span>S$</span> {parseFloat(data.amount).toFixed(2)}</p>
                                  </td>
                                </tr>
                                  <tr>
                                    <td colSpan={3}><hr /></td>
                                  </tr></>)
                              }) : <></>}</> : <></>
                            }
                          </table>
                        </div>
                      </div>
                      <div className={fareData != '' && fareData.surgeprice.length > 0 ? 'col-lg-6 col-12' : 'col-12'}>
                        {fareData != '' && fareData.minimum_fare_status == 0 || fareData.return_minimum_fare_status == 0 ? <>
                          <div className="row justify-content-center" id="max-div">
                            <div className="col-md-12 py-2">
                              <div className="row">
                                <div className="col-6 text-center dist-fare">
                                  <p className="dist-fare-head m-0">Base Fare</p>
                                  <p className="m-0 dist-charge" id="ma-fare-base"><span>S$</span> {parseFloat(fareData.base_fare).toFixed(2)}</p>
                                </div>
                                <div className="col-6 text-center">
                                  <p className="dist-fare-head m-0">Distance Fare</p>
                                  <p className="m-0 dist-charge" id="ma-fare-distance"><span>S$</span> {parseFloat(fareData.distance_price).toFixed(2)}</p>
                                  <p className="m-0 dist-time" id="ma-fare-distance-text">{fareData.total_distance} KMS</p>
                                </div>
                              </div>
                            </div>
                          </div></> : <></>}

                        {fareData != '' && fareData.minimum_fare_status == 1 || fareData.return_minimum_fare_status == 1 ? <>
                          <div className="row justify-content-center" id="min-div">
                            <div className="col-md-12 py-2">
                              <div className="row">
                                <div className="col-12 text-center">
                                  <p className="dist-fare-head m-0">Distance Fare</p>
                                  <p className="m-0 dist-charge" id="m-fare-distance"><span>S$</span> {parseFloat(fareData.distance_price).toFixed(2)}</p>
                                  <p className="m-0 dist-time" id="m-fare-distance-text">{fareData.total_distance} KMS</p>
                                </div>
                              </div>
                            </div>
                          </div></> : <></>}

                        {fareData == '' ? <>
                          <div className="row justify-content-center" id="min-div">
                            <div className="col-md-12 py-2">
                              <div className="row">
                                <div className="col-12 text-center">
                                  <p className="dist-fare-head m-0">Distance Fare</p>
                                  <p className="m-0 dist-charge" id="m-fare-distance"><span>S$</span> {parseFloat(0).toFixed(2)}</p>
                                  <p className="m-0 dist-time" id="m-fare-distance-text">0 KMS</p>
                                </div>
                              </div>
                            </div>
                          </div></> : <></>}
                      </div>
                    </div>
                  </div>
                </div>


                {/* <div className="row justify-content-center">
                  <div className="col-10">
                    <hr className="fare-hr" />
                  </div>
                </div> */}
                {/* <div className="row justify-content-center">
                  <div className="col-md-10 col-12 mt-2">
                    <div className='d-flex justify-content-center fare-total'>Total Price : S$&nbsp;&nbsp;{parseFloat(FareTotalAmount).toFixed(2)}</div> */}
                    {/* <div className="row">
                  <div className="col-5 fare-total p-0">
                    Total Price
                  </div>
                  <div className="col-1 fare-total">
                    :
                  </div>
                  <div className="col-6 fare-list1 p-0">
                    <span id="fare-total">{parseFloat(FareTotalAmount).toFixed(2)} </span>&nbsp;&nbsp;SGD
                  </div>
                </div> */}
                  {/* </div>
                </div>
              </div> */}
               <div className="form-group mb-3 amount">
                  <input type='number' className="form-control"  placeholder="Enter driver payout amount" name='amount' id="amount" onChange={inputChange} min="0" value={driver_payout_amount}/>
                  <span className="error-field text-dark" style={{ marginLeft: "0.5rem" }}>{formError.amount}</span>
                </div>
              <div className="form-group comment">
                <textarea className="form-control" rows="1" placeholder="Comments if anything" name="comment" onChange={inputChange}></textarea>
              </div>

            </div>
            <div className='col-lg-6 col-md-12 col-12 mt-1'>
              <div className="d-flex justify-content-between">
                <h5>Return Trip Booking</h5>
                <label className="switch">
                  <input type="checkbox" id="returnCheck" onChange={ReturnSwitch} />
                  <span className="slider round"></span>
                </label>
              </div>

              <div className={ReturnDiv == 0 ? 'ReturnDiv' : ''}>
                <div className='row mb-1'>
                  {/* <p>Pick Date/Time</p> */}
                  <div className='col-lg-6 col-12 mt-1'>
                    <div className="inner-addon right-addon">
                      <i className="glyphicon glyphicon-user fa fa-calendar textColor"></i>
                      {/* <input type="text" className="form-control rounded-pill" placeholder='Date'/> */}
                      <DatePicker
                        selected={ReSigDate}
                        onChange={onReDateChange}
                        dateFormat='yyyy-MM-dd'
                        minDate={new Date}
                        className='form-control'
                        placeholderText='Date'
                        disabled={ReturnDiv == 0 ? true : false}
                      />
                      <span className="error-field text-dark" style={{ marginLeft: "0.5rem" }}>{formError.rdate}</span>
                    </div>
                  </div>
                  <div className='col-lg-6 col-12'>
                    <div className="inner-addon right-addon">
                      <i className="glyphicon glyphicon-user fa fa-clock textColor"></i>
                      {/* <input type="text" className="form-control rounded-pill" placeholder='Time'/> */}
                      <Datetime dateFormat={false}
                        inputProps={ReturnDiv == 0 ? timePropsE : timeProps}
                        onChange={onReTimeChange}
                        timeConstraints={timeConstraints}
                        // value={ReSigTime}
                      />
                      <span className="error-field text-dark" style={{ marginLeft: "0.5rem" }}>{formError.rtime}</span>
                    </div>
                  </div>
                </div>
                <div className="mb-1">
                  {/* <label className="form-label">Pickup Location</label> */}
                  <Autocomplete onLoad={rfromLoad} onPlaceChanged={onrFromPlaceChanged} options={AutocompleteRestrict}>
                    <input type="text" className="form-control rounded-pill" placeholder='Pickup Location' disabled={ReturnDiv == 0 ? true : false} defaultValue={ReturnDiv == 0 ? '' : drop_name} />
                  </Autocomplete>
                  <span className="error-field text-dark" style={{ marginLeft: "0.5rem" }}>{formError.rpickup}</span>
                </div>

                <div className="mb-1">
                  {/* <label className="form-label">Drop Location</label> */}
                  <Autocomplete onLoad={rtoLoad} onPlaceChanged={onrToPlaceChanged} options={AutocompleteRestrict}>
                    <input type="text" className="form-control rounded-pill" placeholder='Drop Location' disabled={ReturnDiv == 0 ? true : false} defaultValue={ReturnDiv == 0 ? '' : pick_name} />
                  </Autocomplete>
                  <span className="error-field text-dark" style={{ marginLeft: "0.5rem" }}>{formError.rdrop}</span>
                </div>

                <div className="row mb-4">
                  <div className="col-lg-8 col-md-8 col-12">
                    {/* <label className="form-label">Vehicle Type</label> */}
                    <input type="text" className="form-control rounded-pill" value={rvehicle_type} disabled placeholder='Vehicle Type' />
                  </div>
                  <div className={AddonShow == 1 ? 'col-lg-4 col-md-4 col-12' : 'd-none'}>
                    {/* <span className="no_of" style={{ color: 'white' }}>&nbsp;</span> */}
                    <div class="form-check d-flex justify-content-between">
                      {/* <div>
                        <input class="form-check-input" type="checkbox" id="addon" name="addon" onChange={AddonModelOpenRe} checked={ReAddonData.length > 0 ? true : false} disabled={ReturnDiv == 0 ? true : false} />
                        <label class="form-check-label">
                          Add-on Services
                        </label>
                      </div> */}
                      <i className='fa fa-circle-info ms-1' data-tooltip-id="tooltip-addon-return"></i>
                      <p className={ReAddonData.length > 0 ? 'text-end addon-edit' : 'text-end addon-edit d-none'} onClick={AddonModelEditRe}>Edit</p>
                      <ReactTooltip id="tooltip-addon-return" place="top">
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          {ReAddonData.length > 0 ? ReAddonData.map((item, key) => {
                            return (
                              <span>{item.name} - {item.count}</span>
                            )
                          }) : <><p>No add-on selected</p></>}
                        </div>
                      </ReactTooltip>
                    </div>
                  </div>
                </div>

                {/* <div className="confirnBook mb-1">
                  <p className="text-center confirm-title pt-1">Fare Breakdown</p>

                  <div className='row justify-content-center'>
                    <div className="col-md-11 col-11 pt-1">
                      <div className='row'>
                        <div className={refareData != '' && (refareData.surgeprice.length > 0 || refareData.addon_data.length > 0) ? 'col-lg-6 col-12 checkout p-1' : 'd-none'}>
                          <div className="container surge_con" id='fare-scroll'>
                            <table id="fare-table">
                              {refareData != '' ? <>
                                {refareData.surgeprice.length > 0 ? refareData.surgeprice.map((data, i) => {
                                  return (<><tr>
                                    <td style={{ fontSize: '14px' }}>{data.name}</td>
                                    <td>:</td>
                                    <td>
                                      <p className='m-0 p-0 dist-charge'><span>S$</span> {parseFloat(data.surge_amount).toFixed(2)}</p>
                                    </td>
                                  </tr>
                                    <tr>
                                      <td colSpan={3}><hr /></td>
                                    </tr></>)
                                }) : <></>}</> : <></>
                              }
                              {refareData != '' ? <>
                                {refareData.addon_data.length > 0 ? refareData.addon_data.map((data, i) => {
                                  return (<><tr>
                                    <td style={{ fontSize: '14px' }}>{data.name}</td>
                                    <td>:</td>
                                    <td>
                                      <p className='m-0 p-0 dist-charge'><span>S$</span> {parseFloat(data.amount).toFixed(2)}</p>
                                    </td>
                                  </tr>
                                    <tr>
                                      <td colSpan={3}><hr /></td>
                                    </tr></>)
                                }) : <></>}</> : <></>
                              }
                            </table>
                          </div>
                        </div>
                        <div className={refareData != '' && refareData.surgeprice.length > 0 ? 'col-lg-6 col-12' : 'col-12'}>
                          {refareData != '' && refareData.minimum_fare_status == 0 || refareData.return_minimum_fare_status == 0 ? <>
                            <div className="row justify-content-center" id="max-div">
                              <div className="col-md-12 py-2">
                                <div className="row">
                                  <div className="col-6 text-center dist-fare">
                                    <p className="dist-fare-head m-0">Base Fare</p>
                                    <p className="m-0 dist-charge" id="ma-fare-base"><span>S$</span> {parseFloat(refareData.base_fare).toFixed(2)}</p>
                                  </div>
                                  <div className="col-6 text-center">
                                    <p className="dist-fare-head m-0">Distance Fare</p>
                                    <p className="m-0 dist-charge" id="ma-fare-distance"><span>S$</span> {parseFloat(refareData.distance_price).toFixed(2)}</p>
                                    <p className="m-0 dist-time" id="ma-fare-distance-text">{refareData.total_distance} KMS</p>
                                  </div>
                                </div>
                              </div>
                            </div></> : <></>}

                          {refareData != '' && refareData.minimum_fare_status == 1 || refareData.return_minimum_fare_status == 1 ? <>
                            <div className="row justify-content-center" id="min-div">
                              <div className="col-md-12 py-2">
                                <div className="row">
                                  <div className="col-12 text-center">
                                    <p className="dist-fare-head m-0">Distance Fare</p>
                                    <p className="m-0 dist-charge" id="m-fare-distance"><span>S$</span> {parseFloat(refareData.distance_price).toFixed(2)}</p>
                                    <p className="m-0 dist-time" id="m-fare-distance-text">{refareData.total_distance} KMS</p>
                                  </div>
                                </div>
                              </div>
                            </div></> : <></>}

                          {refareData == '' ? <>
                            <div className="row justify-content-center" id="min-div">
                              <div className="col-md-12 py-2">
                                <div className="row">
                                  <div className="col-12 text-center">
                                    <p className="dist-fare-head m-0">Distance Fare</p>
                                    <p className="m-0 dist-charge" id="m-fare-distance"><span>S$</span> {parseFloat(0).toFixed(2)}</p>
                                    <p className="m-0 dist-time" id="m-fare-distance-text">0 KMS</p>
                                  </div>
                                </div>
                              </div>
                            </div></> : <></>}
                        </div>
                      </div>
                    </div>
                  </div>


                  {/* <div className="row justify-content-center">
                    <div className="col-10">
                      <hr className="fare-hr" />
                    </div>
                  </div> */}
                  {/* <div className="row justify-content-center">
                    <div className="col-md-10 col-12 mt-2">
                      <div className='d-flex justify-content-center fare-total'>Total Price : S$&nbsp;&nbsp;{parseFloat(ReFareTotalAmount).toFixed(2)}</div> */}
                      {/* <div className="row">
                    <div className="col-5 fare-total p-0">
                      Total Price
                    </div>
                    <div className="col-1 fare-total">
                      :
                    </div>
                    <div className="col-6 fare-list1 p-0">
                      <span id="fare-total">{parseFloat(ReFareTotalAmount).toFixed(2)} </span>&nbsp;&nbsp;SGD
                    </div>
                  </div> */}
                    {/* </div>
                  </div>
                </div> */}

                <div className="form-group mb-3 amount">
                    <input type='number' className="form-control"  placeholder="Enter driver payout amount" name='ramount' id="ramount" min="0" disabled={ReturnDiv == 0 ? true : false} onChange={inputChange} value={rdriver_payout_amount}/>
                    <span className="error-field text-dark" style={{ marginLeft: "0.5rem" }}>{formError.ramount}</span>
                </div>
                <div className="form-group comment">
                  <textarea className="form-control" rows="1" placeholder="Comments if anything" name="rcomment" onChange={inputChange} disabled={ReturnDiv == 0 ? true : false}></textarea>
                </div>

              </div>
            </div>
          </div>

          <div className="text-end mt-3">
            {cart_button == 1 ? <div className='d-flex justify-content-end'><ThreeDots
              height="40"
              width="40"
              radius="9"
              color="#ff8901"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            /></div> :
              <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="submit" className="btn rounded-pill billCart" onClick={SingaporeNow}>Add Cart</button>
                {cartData.length > 0 ? <input type="button" className="btn rounded-pill billCart" data-bs-toggle="modal" data-bs-target="#exampleModal" data-bs-backdrop="false" value={"View Cart (" + cartData.length + ")"} /> : ''}
              </div>}
          </div>

        </form>
      </div>

      {/* verify button */}
      <VerifyModel email={email} phone={cc + '' + phone} getSuccess={getCheck} />
      <div className='d-none'>
        <input type="button" className="btn rounded-pill" data-bs-toggle="modal" data-bs-target="#VerifyEmail" id="verifyEmail" value='' />
      </div>
      <div className='d-none'>
        <input type="button" className="btn rounded-pill" data-bs-toggle="modal" data-bs-target="#VerifyPhone" id="verifyPhone" value='' />
      </div>

      {/* model for fare estimate */}
      <div>
        <div className='d-none'>
          <input type="button" className="btn rounded-pill" data-bs-toggle="modal" data-bs-target="#estimateModal" id="EstimateModal" data-bs-backdrop="false" />
        </div>

        <div className="modal fade" id="estimateModal" data-bs-keyboard="false" tabIndex="-1"
          aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="false">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content confirnBook">
              <div className="d-flex justify-content-end confirnClose">
                <i className="fa fa-times-circle" data-bs-dismiss="modal" aria-label="Close"></i>
              </div>
              <p className="text-center confirm-title">Fare Breakdown</p>
              <div className="row justify-content-center mt-4">
                <div className="col-10">
                  {showfare == 'from' ? <>
                    <div className="d-flex">
                      <div className="pick-circle"></div>
                      <p className="from-locat">From Location</p>
                    </div>
                    <p className="from-addr" id="fare_pick">{pickup_location}</p>

                    <hr />

                    <div className="d-flex">
                      <div className="drop-circle"></div>
                      <p className="to-locat">To Location</p>
                    </div>
                    <p className="to-addr" id="fare_drop">{drop_location}</p>
                  </> : <>
                    <div className="d-flex">
                      <div className="pick-circle"></div>
                      <p className="from-locat">From Location</p>
                    </div>
                    <p className="from-addr" id="fare_pick">{rpickup_location}</p>

                    <hr />

                    <div className="d-flex">
                      <div className="drop-circle"></div>
                      <p className="to-locat">To Location</p>
                    </div>
                    <p className="to-addr" id="fare_drop">{rdrop_location}</p>
                  </>}

                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-md-10 col-11 px-4 pt-3 fare-head">
                  <p id="fare-category">{rvehicle_type}</p>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-md-10 col-11 px-4 pt-4 checkout">
                  <div className="container surge_con" id={fareData != '' && fareData.surgeprice.length > 0 ? 'fare-scroll' : 'd-none'}>
                    <table id="fare-table">
                      {fareData != '' ? <>
                        {fareData.surgeprice.length > 0 ? fareData.surgeprice.map((data, i) => {
                          return (<><tr>
                            <td>{data.name}</td>
                            <td>:</td>
                            <td>
                              <p className='mb-0 dist-charge'>{parseFloat(data.surge_amount).toFixed(2)}<span>SGD</span></p>
                            </td>
                          </tr>
                            <tr>
                              <td colSpan={3}><hr /></td>
                            </tr></>)
                        }) : <></>}</> : <></>
                      }
                    </table>
                  </div>
                </div>
              </div>

              {fareData != '' && fareData.minimum_fare_status == 1 || fareData.return_minimum_fare_status == 1 ? <>
                <div className="row justify-content-center" id="max-div">
                  <div className="col-md-12 px-4 py-4">
                    <div className="row">
                      <div className="col-6 text-center dist-fare">
                        <p className="dist-fare-head">Base Fare</p>
                        <p className="mb-0 dist-charge" id="ma-fare-base"> {parseFloat(fareData.base_fare).toFixed(2)} <span>SGD</span></p>
                      </div>
                      <div className="col-6 text-center">
                        <p className="dist-fare-head">Distance Fare</p>
                        <p className="mb-0 dist-charge" id="ma-fare-distance"> {parseFloat(fareData.distance_price).toFixed(2)} <span>SGD</span></p>
                        <p className="mb-0 dist-time" id="ma-fare-distance-text">{fareData.total_distance} KMS</p>
                      </div>
                    </div>
                  </div>
                </div></> : <></>}

              {fareData != '' && fareData.minimum_fare_status == 0 || fareData.return_minimum_fare_status == 0 ? <>
                <div className="row justify-content-center" id="min-div">
                  <div className="col-md-12 px-4 py-4">
                    <div className="row">
                      <div className="col-12 text-center dist-fare">
                        <p className="dist-fare-head">Distance Fare</p>
                        <p className="mb-0 dist-charge" id="m-fare-distance"> {parseFloat(fareData.distance_price).toFixed(2)} <span>SGD</span></p>
                        <p className="mb-0 dist-time" id="m-fare-distance-text">{fareData.total_distance} KMS</p>
                      </div>
                    </div>
                  </div>
                </div></> : <></>}


              <div className="row justify-content-center">
                <div className="col-10">
                  <hr className="fare-hr" />
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-md-10 col-10 px-4 py-4">
                  <div className="row">
                    <div className="col-5 fare-total p-0">
                      Total Price
                    </div>
                    <div className="col-1 fare-total">
                      :
                    </div>
                    <div className="col-6 fare-list1 p-0">
                      <span id="fare-total">{parseFloat(FareTotalAmount).toFixed(2)} </span>&nbsp;&nbsp;SGD
                    </div>
                  </div>
                </div>
              </div>

              <div className="row justify-content-center">
                <div className="col-10 mt-3">
                  <hr className="fare-hr" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* add-on model button */}
      <div className='d-none'>
        <input type="button" className="btn rounded-pill" data-bs-toggle="modal" data-bs-target="#AddonData" data-bs-backdrop="false" id="AddonDataModel" />
      </div>
      {!hasRendered ? <></> : <AddonModel AddonData={VehicleAddonData} SelectAddonData={AddonTripType == 'from' ? AddonData : ReAddonData} getAddon={getAddon} />}
    </>
  )
}

export default SingaporeBook